import CryptoJS from 'crypto-js';
import { from, Observable } from 'rxjs';

const IV_SIZE = 12;

export const encode = (message: string) => {
	if (process.env.REACT_APP_SECRET_PASSWORD) {
		const cypherString = CryptoJS.AES.encrypt(message, process.env.REACT_APP_SECRET_PASSWORD).toString();
		const e64 = CryptoJS.enc.Base64.parse(cypherString);
		return e64.toString(CryptoJS.enc.Hex);
	}
	return message;
};

export const decode = (encodedMessage: string) => {
	if (process.env.REACT_APP_SECRET_PASSWORD && encodedMessage.length !== 8) {
		const reb64 = CryptoJS.enc.Hex.parse(encodedMessage);
		const bytes = reb64.toString(CryptoJS.enc.Base64);
		const decrypt = CryptoJS.AES.decrypt(bytes, process.env.REACT_APP_SECRET_PASSWORD);
		return decrypt.toString(CryptoJS.enc.Utf8);
	}
	return encodedMessage;
};

export const encryptPassword = (password: string, key: any): Observable<string> => {
	return encryptAES(password, key);
};

const base64ToBytes = (base64: string): Uint8Array => {
	return new Uint8Array(
		atob(base64)
			.split('')
			.map((char) => char.charCodeAt(0))
	);
};

const bytesToBase64 = (bytes: Uint8Array): string => {
	return btoa(String.fromCharCode(...bytes));
};

const importAESKey = (base64Key: string): Observable<CryptoKey> => {
	const keyBytes = base64ToBytes(base64Key);
	return from(
		crypto.subtle.importKey('raw', keyBytes, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt'])
	) as Observable<CryptoKey>;
};

export const encryptAES = (data: string, base64Key: string): Observable<string> => {
	return new Observable((subscriber) => {
		importAESKey(base64Key).subscribe({
			next: async (key) => {
				try {
					const encoder = new TextEncoder();
					const iv = crypto.getRandomValues(new Uint8Array(IV_SIZE));

					const encryptedData = await crypto.subtle.encrypt(
						{ name: 'AES-GCM', iv },
						key,
						encoder.encode(data)
					);

					// Combine IV + encrypted data and return as Base64
					const combined = new Uint8Array(IV_SIZE + encryptedData.byteLength);
					combined.set(iv, 0);
					combined.set(new Uint8Array(encryptedData), IV_SIZE);

					subscriber.next(bytesToBase64(combined));
					subscriber.complete();
				} catch (error) {
					subscriber.error(error);
				}
			},
			error: (err) => subscriber.error(err),
		});
	});
};
